import type { IconName } from "@rally/ui-kit";
import { say } from "../../localization/say.ts";

export type MenuAct =
  | "pin"
  | "unpin"
  | "snooze"
  | "wake"
  | "archive"
  | "unarchive"
  | "add"
  | "rename"
  | "copyLink"
  | "makePrivate"
  | "makeReadable";

export type MenuRow = {
  act: MenuAct;
  label: string;
  icon: IconName;
  hint?: string;

  separator?: boolean;

  submenu?: true;
};

export type WhatIsOnIt = {
  pinned: boolean;
  muted: boolean;
  snoozed: boolean;
  archived: boolean;
  private: boolean;

  mayAdd: boolean;
};

export function menuFor(on: WhatIsOnIt): MenuRow[] {
  const triage: MenuRow[] = [
    on.snoozed
      ? { act: "wake", label: say("head.wake"), icon: "alarm-clock-off" }
      : { act: "snooze", label: say("head.snooze"), icon: "alarm-clock", submenu: true },
    on.pinned
      ? { act: "unpin", label: say("head.unpin"), icon: "pin-off" }
      : { act: "pin", label: say("head.pin"), icon: "pin" },
    on.archived
      ? { act: "unarchive", label: say("head.unarchive"), icon: "archive-restore" }
      : { act: "archive", label: say("head.archive"), icon: "archive" },
  ];

  const membership: MenuRow[] = on.mayAdd
    ? [{ act: "add", label: say("head.addSomebody"), icon: "user-plus", separator: true }]
    : [];

  const edits: MenuRow[] = [
    {
      act: "rename",
      label: say("head.rename"),
      icon: "pencil",

      separator: true,
    },
    { act: "copyLink", label: say("head.share"), icon: "link", hint: say("head.shareMeans") },
  ];

  const consequential: MenuRow[] = [
    on.private
      ? {
          act: "makeReadable",
          label: say("head.makeReadable"),
          icon: "unlock",
          hint: say("head.readableMeans"),
          separator: true,
        }
      : {
          act: "makePrivate",
          label: say("head.makePrivate"),
          icon: "lock",
          hint: say("head.privateMeans"),
          separator: true,
        },
  ];

  return [...triage, ...membership, ...edits, ...consequential];
}
